import AppModule from "@/app/modules/module";
import Guards from '@/app/middleware/guards'
import {authWorker, webWorker} from '@/app/middleware/register'

export default new AppModule('w-project')
    .routers([
        {
            path: '/worker/',
            component: AppModule.layout.WorkerLayout,
            beforeEnter: Guards([webWorker,authWorker]),
            children: [
                {
                    path: 'search',
                    component: () => import('./views/search'),
                    meta: {
                        title: 'Backstage | 案件検索',
                        bodyClass: ''
                    }
                },
            ]
        },
    ])
    .register()
